/* eslint-disable no-unused-vars */
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import FestivalIcon from '@mui/icons-material/Festival';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SignpostIcon from '@mui/icons-material/Signpost';
import { motion } from 'framer-motion';
import React from 'react';
import { IMAGE_BASE_URL } from '../config';
import { capitalize } from '../Utils/Helpers';
import './Agenda.css';

const EventCard = ({ event, delay, onClick }) => {
  console.log({ event });
  const itemVariants = {
    hidden: { y: '100vh', opacity: 0 },
    visible: {
      y: '0',
      opacity: 1,
      transition: {
        duration: 0.08,
        type: 'spring',
        damping: 25,
        stiffness: 500,
        delay: delay / 10,
      },
    },
  };
  let dateFormat = null;
  let heuresFormat = null;
  if (event.date) {
    dateFormat = new Date(event.date).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
  if (event.time) {
    const [hours, minutes] = event.time.split(':');
    heuresFormat = `${hours}h${minutes}`;
  }

  return (
    <motion.article
      className="new_event "
      variants={itemVariants}
      initial="hidden"
      animate="visible"
    >
      <div
        className="w-full h-56 overflow-hidden border-b-2 border-white bg-no-repeat bg-cover bg-[center center] overflow-hidden"
        style={{
          backgroundImage: `url(${IMAGE_BASE_URL}/images/miniatures/${event.background})`,
        }}
      >
        {event.background && (
          <motion.img
            className="w-full h-full object-cover"
            src={`${IMAGE_BASE_URL}/images/agenda/${event.background}`}
            loading="lazy"
            alt={`Afiche du évènement ${event.title}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 2 } }}
          />
        )}
      </div>

      <div className="flex flex-col justify-around flex-1 text-start p-2 font-[1.2rem] gap-1">
        <div className="text-start border-b border-black/50 flex justify-between items-center">
          <h3 className="font-semibold text-2xl ">{capitalize(event.title)}</h3>
          {event.id_spectacle && (
            <InfoOutlinedIcon onClick={onClick} style={{ cursor: 'pointer' }} />
          )}
        </div>
        <div className="flex flex-col">
          {!event.date ? (
            <div className="flex items-center gap-2">
              <CalendarMonthIcon className="p_events_cards" />
              Prochainement
            </div>
          ) : (
            <>
              <div className="flex items-center gap-2">
                <CalendarMonthIcon className="p_events_cards" />
                {dateFormat ? dateFormat : 'Date à confirmer'}
              </div>
              <div className="flex items-center gap-2">
                <AccessTimeIcon className="p_events_cards" />
                {heuresFormat ? heuresFormat : 'Horaire à confirmer'}
              </div>
            </>
          )}
        </div>
        <div className="border-t border-black/50 pt-2 flex flex-col gap-2">
          {event.tickets_link && (
            <a
              href={event.tickets_link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline w-fit"
              aria-label={`Lien d'achat des tickets pour le événement ${event.title}`}
            >
              <span className="flex gap-2">
                <ConfirmationNumberIcon className="p_events_cards" />
                Achetez vos tickets ici !
              </span>
            </a>
          )}
          <a
            href={event.event_link ? event.event_link : '#'} // Si no hay link, usa "#"
            target={event.event_link ? '_blank' : undefined} // Solo abre en nueva pestaña si hay link
            rel={event.event_link ? 'noopener noreferrer' : undefined} // Solo agrega atributos si hay link
            className={`hover:underline ${
              !event.event_link && 'cursor-default hover:no-underline'
            }`} // Cambia el cursor si no hay link
            aria-label={
              event.event_link
                ? `Lien de l'organisateur de le spectacle ${event.title}`
                : 'Aucun lien disponible'
            }
            onClick={(e) => {
              if (!event.event_link) {
                e.preventDefault(); // Previene la acción predeterminada si no hay link
              }
            }}
          >
            <span className="flex gap-2">
              <FestivalIcon className="p_events_cards" />
              {capitalize(event.place)}
            </span>
          </a>
          <a
            href={event.google_link}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
            aria-label={`Lien adresse Google Maps pour le spectacle ${event.title}`}
          >
            <span className="flex gap-2">
              <SignpostIcon className="p_events_cards" />
              <p className="pl-1 text-lg">{event.adresse}</p>
            </span>
          </a>
        </div>
      </div>
    </motion.article>
  );
};

export default EventCard;
